var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolicyNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 5,
    d: "M50.9388+6.57353C50.9388+6.57353+44.2209+12.5916+35.6169+16.2546C27.013+19.9175+15.7877+20.322+15.7877+20.322C15.7877+20.322+15.9757+35.7839+16.2276+46.9982C16.4795+58.2125+16.7466+64.4062+18.0232+68.2058C19.2998+72.0054+21.8143+74.1849+30.239+81.1925C38.6638+88.2001+51.0295+94.2563+51.0295+94.2563L77.2568+76.5402C77.2568+76.5402+81.6425+73.1326+83.605+69.081C85.4612+65.2489+85.5729+55.0378+85.573+55.0378L85.3825+20.4535C85.3825+20.4535+75.6174+20.513+67.1858+16.7352C58.7542+12.9575+50.9389+6.57354+50.9388+6.57353ZM50.9615+12.686C50.9615+12.686+57.7318+18.2145+65.0364+21.4874C72.3411+24.7602+80.8027+24.7113+80.8027+24.7113L80.966+54.6705C80.966+54.6705+80.8691+63.5165+79.261+66.8364C77.5608+70.3465+73.7607+73.3026+73.7607+73.3026L51.0386+88.6472C51.0386+88.6472+40.3265+83.4001+33.0277+77.3292C25.729+71.2582+23.5503+69.3709+22.4443+66.0792C21.3384+62.7874+21.1072+57.421+20.889+47.7056C20.6708+37.9901+20.5081+24.5935+20.5081+24.5935C20.5081+24.5934+30.2306+24.2481+37.6846+21.0747C45.1386+17.9013+50.9615+12.686+50.9615+12.686ZM66.3378+38.9405L48.1093+56.3392L37.739+46.4767C37.739+46.4767+36.0151+46.2086+35.1816+46.9211C34.3481+47.6336+34.4062+49.3244+34.4062+49.3244C34.4062+49.3244+38.6347+53.5546+42.1375+56.7654C45.6402+59.9762+47.1149+61.7792+48.0458+62.3791C48.9768+62.9789+53.6884+57.7091+54.0041+57.4048C58.613+52.9616+69.3466+42.0045+69.3124+42.2098C69.2909+42.3396+69.5179+40.587+68.732+39.6796C68.0498+38.8918+66.3378+38.9405+66.3378+38.9405Z",
    fill: "#ffffff",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyNode);
export default __webpack_public_path__ + "static/media/Policy_Node.d94528f5b8db0e74b5f05dfde6e7ecc0.svg";
export { ForwardRef as ReactComponent };